module.exports = "./img/f7b5fa32eaf0ddf627ba217752d7d0de.png";